import { InputLabel, MenuItem, Box, Select } from "@mui/material";

interface Option {
  id: string | number;
  name: string;
}

interface SelectFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: Option[];
  allLabel?: string;
  required?: boolean;
}

export default function FormDropDown({
  label,
  value,
  onChange,
  options,
  allLabel,
  required = true,
}: SelectFieldProps) {
  return (
    <Box mb={3}>
      <InputLabel sx={{ fontWeight: 600, fontSize: "1rem", mb: 1 }}>
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </InputLabel>
      <Select
        fullWidth
        displayEmpty
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <MenuItem value={""}>{allLabel}</MenuItem>
        {options.map((opt) => (
          <MenuItem key={opt.id} value={String(opt.id)}>
            {opt.name}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
